import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants';


/*

Props:


*/

const StyledImg = styled.img`
  color: ${constants.color.primary};
  margin-right: 12px;
  margin-top: -6px;
  fill: ${constants.color.primary};
  height: ${props => (props.height ? props.height : 35)}px;
`;

const ModuleIcon = ({ styles, children, ...rest }) => (
    <StyledImg style = {styles} {...rest}>
        { children }
    </StyledImg>
)

export default ModuleIcon



// WEBPACK FOOTER //
// ./src/js/components/ModuleList/ModuleIcon.jsx